import * as React from "react";

import JobDetail from "../../components/Job/JobDetail";

const JobDetailPage: React.FC = () => <JobDetail />;

export default JobDetailPage;
